import React, { useState, useEffect } from "react";
import UserWorkSpaces from "./workSpace/workSpaces";
import UserMeetingRooms from "./meetingRoom/meetingRooms";
import { useLocation } from "react-router-dom";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton } from "antd";

const PackageServices = () => {
  const PACKAGEDATA = gql`
    query ($paginateInput: PaginateInput!, $searchInput: PackageSearchInput!) {
      getPackages(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        amountRial
        strikethroughRial
        packageType
        days
        sessions
        image
        product{
            name
            id
          }
      }
    }
  `;

  const [packagesData, setPackagesData] = useState(null);
  const [getPackages, packages] = useLazyQuery(PACKAGEDATA, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setPackagesData(data?.getPackages);
    },
    onError(err) {
      console.log("error while getting packages: ", err.message);
    },
  });

  const location = useLocation();
  const { pathname } = location;
  const currentPath = pathname.split("/")[2];

  useEffect(() => {
    getPackages({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 20,
          sort: "createdAt",
          sortDir: "asc",
        },
        searchInput: {
          textSearch: null,
          packageType:
            currentPath === "work-spaces"
              ? "WORK_SPACE"
              : currentPath === "meeting-rooms"
              ? "MEETING_ROOM"
              : null,
        },
      },
    });
  }, [pathname]);
  if (packages.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
    if (packages.data && currentPath === "work-spaces")
      return <UserWorkSpaces data={packagesData} />;

  if (packages.data && currentPath === "meeting-rooms")
    return <UserMeetingRooms data={packagesData} />;
};

export default PackageServices;
